export default __webpack_public_path__ + "static/media/3.79b55074.jpg";